import Register from './Register'
import enhancer from './enhancers'

export default enhancer(Register)
